/**
 * LeaveApplicationFormPage
 *
 * Deep-link target for the QR code printed on a leave application's form PDF
 * (LeaveApplicationFormPdfService.buildVerificationUrl on the backend): scanning that
 * code opens this exact application's live form here, so a printed copy can always be
 * checked against the current record. Reuses the same modal used from the Reports →
 * "Individual Application" tab, just mounted directly from a route instead of a click.
 *
 * Gated by the same ProtectedRoute permission requirement as the PDF endpoint itself
 * (HR_LEAVE_REPORT_VIEW / HR_LEAVE_MANAGE, see router.tsx) -- if the person isn't signed
 * in yet, ProtectedRoute bounces them to /login and LoginPage sends them straight back
 * here afterward.
 */
import { useNavigate, useParams } from "react-router-dom";
import { LeaveApplicationFormModal } from "../components/LeaveApplicationFormModal";

export default function LeaveApplicationFormPage() {
  const params = useParams();
  const id = Number(params.id);
  const navigate = useNavigate();

  if (!Number.isFinite(id) || id <= 0) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-sm font-semibold text-red-600">
        Invalid application reference.
      </div>
    );
  }

  return (
    <LeaveApplicationFormModal
      applicationId={id}
      onClose={() => navigate("/hr/leave/reports", { replace: true })}
    />
  );
}
